import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19acd47e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rail" }, null, -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "knob-icon" }, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "knob-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['slider', { block: _ctx.block }])
  }, [
    _createElementVNode("div", {
      ref: "container",
      class: "container",
      onPointerdown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startDrag($event)))
    }, [
      _hoisted_1,
      _createElementVNode("div", {
        class: "range",
        style: _normalizeStyle(_ctx.range)
      }, null, 4 /* STYLE */),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markPos, (pos, ix) => {
        return (_openBlock(), _createElementBlock("div", {
          key: ix,
          class: "mark",
          style: _normalizeStyle(pos)
        }, null, 4 /* STYLE */))
      }), 128 /* KEYED_FRAGMENT */)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.knobPos, (pos, ix) => {
        return (_openBlock(), _createElementBlock("div", {
          key: ix,
          class: _normalizeClass(['knob', { active: _ctx.targetId === ix }]),
          style: _normalizeStyle(pos)
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, _toDisplayString(Array.isArray(_ctx.modelValue) ? _ctx.modelValue[ix] : _ctx.modelValue), 1 /* TEXT */)
        ], 6 /* CLASS, STYLE */))
      }), 128 /* KEYED_FRAGMENT */))
    ], 544 /* HYDRATE_EVENTS, NEED_PATCH */)
  ], 2 /* CLASS */))
}